import React, {useState} from 'react'
import toast from 'react-hot-toast';
import { db } from "./Firebase";
import { setDoc, collection, getDocs, query, doc, where } from "firebase/firestore";
import Instagram from '../assets/Instagram'
import Facebook from '../assets/Facebook'
import Tiktok from '../assets/Tiktok'
import { isValidEmail, toDateTime } from './Home';
import emailjs from "@emailjs/browser"
import { Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import { motion } from "framer-motion";
import { useInView } from "react-intersection-observer";

const Footer = () => {
  const [email, setEmail] = useState("");
  const [name, setName] = useState("");
  const [loading, setLoading] = useState(false);
  const colRef = collection(db, "newsletter_signups");

  const signup = async () => {
    try {
      if (loading) return;
      if (!email.trim() || !name.trim() || !isValidEmail(email)) return;
      setLoading(true);
      const docSearch = await getDocs(
        query(colRef, where("email", "==", email))
      );
      if (docSearch.docs.length == 0) {
        await setDoc(doc(colRef), { email, name, entry_date: toDateTime() });
        emailjs
          .send(
            "service_h4br5is",
            "template_3bi0wub",
            { name, email },
            { publicKey: "grg76XmeXnwqwv5cy" }
          )
          .then(
            (response) => {
              window.location.replace("/thanks");
              console.log("SUCCESS!", response.status, response.text);
            },
            (error) => {
              console.log("FAILED...", error);
              setLoading(false);
              toast("Error sending email", {
                icon: "⚠️",
              });
            }
          );
        //toast.success("Thank you for signing up!")
      } else {
        //console.log("Already exists");
        toast("You have already subscribed", {
          icon: "⚠️",
        });
        setLoading(false);
      }
    } catch (err) {
      toast.error("Request error");
      console.log(err);
      setLoading(false);
      toast("An error has occured", {
        icon: "⚠️",
      });
    }
  };
  const [ref1, inView1] = useInView({ triggerOnce: true });
  return (
    <motion.div
      className="footer"
      ref={ref1}
      initial={{ opacity: 0, scale: 0.8 }}
      animate={inView1 ? { opacity: 1, scale: 1 } : {}}
      transition={{ duration: 0.8 }}
    >
      <div id="NewsPaper">
        <p
          className="first-to-know"
          style={{ textAlign: "center", marginTop: 0 }}
        >
          SUBSCRIBE TO OUR NEWSLETTER TO STAY UPDATED!
        </p>
        <input
          value={name}
          onChange={(e) => setName(e.target.value)}
          type="text"
          placeholder="Name"
          className="footer-input"
        />
        <input
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          type="email"
          placeholder="Email"
          className="footer-input"
        />
        <motion.div
          whileHover={{ scale: 1.2 }}
          transition={{ type: "spring", stiffness: 500, damping: 30 }}
          className="subscribe-btn"
          style={{ marginTop: 15, opacity: loading ? 0.5 : 1 }}
          onClick={() =>
            !email.trim() || !name.trim() || !isValidEmail(email)
              ? toast("Please enter your name & email", { icon: "⚠️" })
              : signup()
          }
        >
          {!loading ? (
            <p>SUBSCRIBE</p>
          ) : (
            <Spin
              indicator={
                <LoadingOutlined
                  style={{
                    fontSize: 24,
                    color: "white",
                  }}
                  spin
                />
              }
            />
          )}
        </motion.div>
      </div>

      <div>
        <div>
          <a
            href="https://www.instagram.com/thebookerapp?igsh=OWEwYXg5YjQ0NXQx"
            target="_blank"
          >
            <Instagram width={30} height={30} />
          </a>
          <a
            href="https://www.facebook.com/profile.php?id=61558283653706"
            target="_blank"
          >
            <Facebook width={30} height={30} />
          </a>
          <a
            href="https://www.tiktok.com/@thebooker.app?_t=8laJs404Hl2&_r=1"
            target="_blank"
          >
            <Tiktok width={30} height={30} />
          </a>
        </div>
        <p>TheBooker App. All Rights Reserved.</p>
      </div>
    </motion.div>
  );
};

export default Footer